import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addSpaceBeforeNumber'
})
export class AddSpaceBeforeNumberPipe implements PipeTransform {


  transform(value: string): string {
    if (!value) return '';
    return value.replace(/([a-zA-Z])(\d+)/, '$1 $2');
  }


}
